import { combineReducers } from 'redux';
import triageGyantResultsReducer, { TriageGyantResultsState } from './results';
import triageGyantConditionDetailReducer, {
  TriageGyantConditionDetailState
} from './conditionDetail';
import triageGyantSessionTokenReducer, { TriageGyantSessionTokenState } from './sessionToken';

export interface GyantTriageState {
  results: TriageGyantResultsState;
  conditionDetail: TriageGyantConditionDetailState;
  sessionToken: TriageGyantSessionTokenState;
}

export default combineReducers({
  results: triageGyantResultsReducer,
  conditionDetail: triageGyantConditionDetailReducer,
  sessionToken: triageGyantSessionTokenReducer
});
